<template id="app-loader">
  <div class="app-loader bg-primary bg-gradient" v-if="visible">
    <div>
      <span class="loader"></span>
      <p v-if="title">{{ title }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "AppLoader",
  template: "#app-loader",
  props: {
    title: {
      type: String,
      require: false,
    },
    visible: {
      type: Boolean,
      require: true,
    },
  },
};
</script>
<style scoped>
.app-loader {
  position: fixed;
  float: left;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  display: flex;
  align-content: center;
  align-items: center;
  z-index: 99998;
}
.app-loader > div {
  width: 100%;
  text-align: center;
}
.app-loader > div > p {
  color: rgba(255, 255, 255, .8);
  font-weight:600;
}

.loader {
  width: 68px;
  height: 68px;
  display: inline-block;
  position: relative;
}
.loader::after,
.loader::before {
  content: '';  
  box-sizing: border-box;
  width: 68px;
  height: 68px;
  border-radius: 50%;
  border: 2px solid #fff;
  position: absolute;
  left: 0;
  top: 0;
  animation: animloader 2s linear infinite;
}
.loader::after {
  animation-delay: 1s;
}

@keyframes animloader {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}


</style>